/**
 * Utility functions for feature flags.
 * The feature flags are stored in the settings store.
 * This file provides a convenient way to check if a feature flag is enabled without
 * having to import the settings store and map the state in each component.
 */

import { useSettingsStore } from '@stores/settings';

/**
 * Checks if a feature flag is enabled by using the settings store.
 * @param {string} feature - The feature flag to check.
 * @return {boolean} - True if the feature flag is enabled, false otherwise.
 */
function isFeatureEnabled(feature) {
    if (!feature || typeof feature !== 'string') {
        console.error('Invalid feature flag:', feature);
        return false;
    }

    const settingsStore = useSettingsStore();
    return settingsStore.getFeatureFlagValue(feature);
}

export { isFeatureEnabled };
